export const infoOnboardingTitle = [
    {
        title: " Configura la autorización digital para colaboradores",
        subtitle:
            "Los colaboradores que activen la huella dactilar y/o PIN podrán realizar las siguientes tareas diarias de foma más sencilla y rápida.",
    },
]
export const infoOnboarding = [
    {
        icon: "restaurantFill",
        title: "Room service, restaurante y cocina",
        subtitle: "Gestión de ordenes por preparar, entregar, editar y cancelar.",
    },
    {
        icon: "LockUnlockFill",
        title: "Permisos en el hotel",
        subtitle: "Cambio de estatus de habitaciones y cancelaciones.",
    },
    {
        icon: "currencyRefundFill",
        title: "Autorización de procesos",
        subtitle: "Solo el personal autorizado podrá confirmar o actualizar transacciones.",
    },
]
